<template>
  <el-container>
    <el-main>
      <div ref="printArea" class="SaleStatementPrint">
        <div
          v-for="(contract, cindex) in data"
          :key="contract.id"
          v-bind:class="{ 'page-break': cindex > 0 }"
        >
          <div
            v-for="(details, index) in organizeDetail(contract)"
            :key="index"
            class="a4-size"
          >
            <div class="h-half" v-for="(item, index) in iteration" :key="index">
              <div v-if="index === 1" class="dashedline"></div>
              <div class="flex mb-default">
                <div class="flex-auto" style="margin:auto 100px;">
                  <span class="font-big_1 bold align-center"
                    >매출(발주)전표</span
                  >
                </div>
                <div class="sign-box" style="width: 300px;">
                  <table class="s-full border">
                    <tr style="font-size:20px; height: 20px">
                      <th>주 문</th>
                      <th>생 산</th>
                      <th>관 리</th>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                  </table>
                </div>
              </div>
              <table
                class="table-own"
                border="1"
                cellspacing="0"
                cellpadding="10"
              >
                <tr class="text-align-center">
                  <td width="10%" rowspan="2">상 호</td>
                  <td rowspan="2" width="30%">{{ contract.customer_name }}</td>
                  <td width="20%">접수일</td>
                  <td width="25%">납품(시공, 납품)</td>
                  <td width="15%" height="30px" class="align-left pl-default">
                    오전
                  </td>
                </tr>
                <tr class="text-align-center">
                  <td>{{ contract.contract_date }}</td>
                  <td>
                    <div class="align-right">
                      월<span style="margin-left:80px;">일</span>
                    </div>
                  </td>
                  <td height="30px" class="align-left pl-default">오후</td>
                </tr>
              </table>

              <div class="mt-default mb-default">
                <table
                  width="100%"
                  cellpadding="5"
                  cellspacing="0"
                  border="1"
                  class="statement-table"
                >
                  <tr>
                    <th width="30%">품명</th>
                    <th width="15%">규격</th>
                    <th width="8%">수량</th>
                    <th width="20%">현장</th>
                    <th>비고</th>
                  </tr>
                  <tr v-for="(detail, index) in details" :key="index">
                    <td>
                      <div class="splice-name">
                        <AFitText>{{ detail.product_name }}</AFitText>
                      </div>
                    </td>
                    <td class="align-center">
                      <AFitText>{{ detail.size }}</AFitText>
                    </td>
                    <td class="align-center">{{ detail.amount }}</td>
                    <td>
                      <div class="customer-name">
                        <AFitText>{{ detail.field }}</AFitText>
                      </div>
                    </td>
                    <td>
                      <div class="customer-name">
                        <AFitText>{{ detail.desc }}</AFitText>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="handleClickPrint"
        @click="handleClickPrint"
        >{{ $t("button.print") }} (F8)</el-button
      >
      <el-button @click="handleClickClose" class="right"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import Vue from "vue";
import Print from "@/plugins/print/print";
import AFitText from "@/shared/AFitText";

Vue.use(Print);

export default {
  components: { AFitText },
  name: "SaleStatementPrint",
  data() {
    return {
      iteration: ["1", "2"],
    };
  },
  props: {
    config: {
      type: Object,
      default: function() {
        return {
          margin_left: 0,
          margin_top: 0,
        };
      },
    },
    data: {
      type: Array,
      require: true,
    },
  },
  methods: {
    organizeDetail(data) {
      let length = Math.ceil(data.details.length / 10);
      let details = this.util.clone(data.details);
      let ret = [];
      for (var i = 0; i < length; i++) {
        ret.push(details.splice(0, 10));
      }
      return ret;
    },
    handleClickPrint() {
      const id = "print-orientation-style";
      document.getElementById(id)?.remove();
      const s = document.createElement("style");
      s.id = id;
      s.media = "print";
      s.textContent = `@page { size: A4 portrait}; }`;
      document.head.appendChild(s);

      this.$print(this.$refs.printArea);
      setTimeout(() => document.getElementById(id)?.remove(), 0);
    },
    handleClickClose() {
      this.$emit("completed");
    },
  },
};
</script>
<style lang="scss">
.SaleStatementPrint {
  .sign-box {
    width: 300px;
    height: 100px;
  }
  .splice-name {
    overflow: hidden;
    height: 30px;
  }
  .table-own {
    width: 100%;
    font-size: 25px;
    font-weight: bold;
    text-align: center;
    border-collapse: collapse;
    border-color: black;
  }
  .dashedline {
    margin-bottom: 30px;
    border-bottom: 2px dashed black;
  }
  .statement-table {
    width: 100%;
    font-size: 23px;
    border-collapse: collapse;
    border-color: black;
  }
  .customer-name {
    width: 220px;
    line-height: 15px;
  }
}
</style>
<style type="text/css" media="print">
.SaleStatementPrint {
  page: a4portrait;
  font-family: "돋움";
  font-size: 12px;
  color: black;
}
.page-break {
  page-break-after: always;
}
@media print {
  .a4-size {
    height: 389mm;
  }
}
</style>
